import { render, staticRenderFns } from "./extraFile.vue?vue&type=template&id=67d1e7ef&scoped=true&"
import script from "./extraFile.vue?vue&type=script&lang=js&"
export * from "./extraFile.vue?vue&type=script&lang=js&"
import style0 from "./extraFile.vue?vue&type=style&index=0&id=67d1e7ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1e7ef",
  null
  
)

export default component.exports